import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from '@heroicons/react/solid'
import classNames from 'classnames'
import { useFormikContext } from 'formik'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { PhoneWithPurpleLine } from 'shared/components/icon-pack/icons'
import { useSocketInstance } from 'shared/contexts/socket/socket-context'

import { formikValuesType } from '../../index'
import { Line } from './line'
import { Operator, operatorWithRequested } from './Operator'

export type SideBarProps = {
  hasArrow?: boolean
  onClickArrow?: () => void
  operators: operatorWithRequested[]
  isOpen?: boolean
  startDate: string | Date
}

const newGreenBadgeClassName =
  'flex justify-center items-center xl:hidden px-2 bg-chinese-white rounded-[50px] text-green-cta font-medium text-[12px] leading-[30px]  mb-[30px] left-[15px] cursor-pointer'

function SidebarComponent(props: SideBarProps) {
  const { operators, hasArrow = false, onClickArrow, isOpen, startDate } = props
  const [duration, setDuration] = useState<string>('')
  const { values } = useFormikContext<formikValuesType>()
  const socket = useSocketInstance()

  useEffect(() => {
    const momentStartDate = moment(startDate)

    const intervalId = setInterval(() => {
      if (startDate) {
        const durationInSec = moment().diff(momentStartDate, 'second')
        const minutes = Math.floor(durationInSec / 60)
          .toString()
          .padStart(2, '0')
        const seconds = (durationInSec % 60).toString().padStart(2, '0')
        setDuration(`${minutes}:${seconds}`)
      }
    }, 1000)

    const hangUpCallback = () => {
      clearInterval(intervalId)
    }

    socket?.on('hangup', hangUpCallback)

    return () => {
      hangUpCallback()
      socket?.off('hangup', hangUpCallback)
    }
  }, [])

  return (
    <div className=" flex flex-col items-center bg-white !w-[100%] pt-3 h-full px-2">
      <div className={''}>
        {hasArrow &&
          // ----------------------- if drawer is open show arrow right -----------------------
          (isOpen ? (
            <ChevronDoubleRightIcon
              className={
                'w-[14px] text-gray-medium absolute left-[12px] cursor-pointer'
              }
              onClick={onClickArrow}
            />
          ) : (
            // ------------------------ if is not open : if type is lead show text new else show arrow----------------------
            <>
              <ChevronDoubleLeftIcon
                className={
                  ' hidden xl:block w-[14px] text-gray-medium xl:absolute mb-[30px] left-[15px] cursor-pointer'
                }
                onClick={onClickArrow}
              />
              {values?.lead?.type === 'lead' ? (
                <div
                  className={classNames(newGreenBadgeClassName)}
                  onClick={onClickArrow}
                >
                  جدید
                  <ChevronDoubleLeftIcon className={' w-[14px] mb-[2px]'} />
                </div>
              ) : (
                <ChevronDoubleLeftIcon
                  className={
                    '  xl:hidden w-[14px] text-gray-medium xl:absolute mb-[30px] left-[15px] cursor-pointer'
                  }
                  onClick={onClickArrow}
                />
              )}
            </>
          ))}
      </div>
      <div
        className={
          ' rounded-full border  w-[44px] h-[44px] flex justify-center items-center'
        }
      >
        <PhoneWithPurpleLine className={' w-[27px] h-[27px]'} />
      </div>
      {/*------------------------------- timer --------------------------------*/}
      <div
        className={
          'flex justify-center text-gray-medium font-medium text-[13px] leading-[22px] h-[22px] mt-1'
        }
      >
        {duration}
      </div>

      {/*------------------------------- end timer --------------------------------*/}
      {operators?.length > 0 ? (
        <>
          <Line className={'!mb-[10px]'} />
          <div className={'space-y-[10px] w-[100%]'}>
            {operators?.map((operatorData, index) => {
              return (
                <>
                  <Operator
                    {...operatorData}
                    key={index}
                    isDrawerOpen={isOpen}
                  />
                  {index < operators?.length - 1 && <Line />}
                </>
              )
            })}
          </div>
        </>
      ) : null}
    </div>
  )
}

export default SidebarComponent
